import {
  SCHEMA_VERSION,
  type CampaignDraft,
  type CampaignDraftData,
} from "src/services/CampaignDraftTypes";
import type { GeneratedTemplate } from "../AiEmail/AiCampaignTypes";
import {
  draftContentToTemplate,
  readString,
  readStringList,
  toCurrentStep,
  toStepIndex,
} from "../../../shared/CampaignDraftUtils";
import { EMAIL_TEMPLATE_WIZARD_STEPS } from "./TemplateEditorConstants";

interface TemplateDraftState {
  stepIndex: number;
  campaignName: string;
  subjectLine: string;
  sendTo: string[];
  excludeList: string[];
  replyTo: string;
}

export interface RestoredTemplateDraft extends TemplateDraftState {
  template: GeneratedTemplate | null;
}

export const buildTemplateDraftData = ({
  stepIndex,
  campaignName,
  subjectLine,
  sendTo,
  excludeList,
  replyTo,
}: TemplateDraftState): CampaignDraftData => ({
  schema_version: SCHEMA_VERSION,
  wizard: "template",
  current_step: toCurrentStep(stepIndex),
  campaign_name: campaignName.trim(),
  send_to: sendTo,
  dont_send_to: excludeList,
  subject_line: subjectLine.trim(),
  reply_to: replyTo.trim(),
});

export const restoreTemplateDraft = (draft: CampaignDraft): RestoredTemplateDraft => {
  const { data, content } = draft;
  return {
    stepIndex: toStepIndex(data, EMAIL_TEMPLATE_WIZARD_STEPS.length),
    campaignName: readString(data.campaign_name),
    subjectLine: readString(data.subject_line),
    sendTo: readStringList(data.send_to),
    excludeList: readStringList(data.dont_send_to),
    replyTo: readString(data.reply_to),
    template: draftContentToTemplate(content),
  };
};
